import { defineStore } from 'pinia';
import { profileService } from '../services/api/profile.service';
import { InstitutionData, InstitutionProfile, UserProfile } from '../types';
import { institutionRole } from '../enums/institutionRole';

interface UserProfileState {
  profile: UserProfile | null;
  isLoading: boolean;
  error: string | null;
}

export const useUserProfileStore = defineStore('userProfile', {
  state: (): UserProfileState => ({
    profile: null,
    isLoading: true,
    error: null,
  }),

  getters: {
    isLoggedIn: state => !!state.profile,
    hasProfile: state => !!state.profile && !state.isLoading && !state.error,
    institutionProfile: (state): Partial<InstitutionProfile> =>
      state.profile?.institutionProfile || { id: 0, institutionRoles: [] },
    institutionRoles: (state): institutionRole[] =>
      state.profile?.institutions.map(institution => institution.institutionRole) || [],
    institutions: (state): InstitutionData[] => state.profile?.institutions || [],
  },

  actions: {
    async fetchProfile() {
      this.isLoading = true;
      this.error = null;

      try {
        this.profile = await profileService.getProfileContext();
      } catch (error) {
        this.error = error instanceof Error ? error.message : 'Failed to fetch profile';
        this.profile = null;
      } finally {
        this.isLoading = false;
      }
    },

    clearProfile() {
      this.profile = null;
      this.error = null;
    },

    setProfile(profile: UserProfile) {
      this.profile = profile;
      this.error = null;
    },

    setLoading(value: boolean) {
      this.isLoading = value;
    },
  },
});
